import { useLocale } from 'next-intl';
import { useMemo } from 'react';
import { isBrowsingWithoutOrderFlowLocale } from '@/core/constants/browse-only-resolution';
import useOrganizationsQuery from '@/core/queries/eva/use-organizations-query';

/** True when cart, checkout, account ordering, and EVA catalog must be hidden. */
const useIsNonEvaCountry = (): boolean => {
  const locale = useLocale();
  const { data: organizations } = useOrganizationsQuery();

  return useMemo(() => {
    const evaCountryIds = organizations?.map(org => org.countryId);
    return isBrowsingWithoutOrderFlowLocale(locale, evaCountryIds);
  }, [locale, organizations]);
};

export default useIsNonEvaCountry;
